/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateAdminDto = {
  /**
   * 이메일
   */
  email: string;
  /**
   * 비밀번호
   */
  password: string;
  /**
   * 이름
   */
  name?: string;
  /**
   * 역할
   */
  role: CreateAdminDto.role;
};
export namespace CreateAdminDto {
  /**
   * 역할
   */
  export enum role {
    SUPER = "SUPER",
    STAFF = "STAFF",
  }
}
